import { __assign } from "tslib";
import { requestWithAuthAndRetry } from '../requestWithAuthAndRetry';
import { requestWithOfficeContext } from '../requestWithOfficeContext';
// See httpPost for argument docs
export function httpGet(eventName, url, requestConfig, jwtAuthEnabled, getAccessToken, officeHomeApiRoot, officeCorrelationId, tokenConsumer, xhrOptions, strategy) {
    if (xhrOptions === void 0) { xhrOptions = {}; }
    var fromCache = strategy === "cache-only" /* CacheOnly */;
    // If cached data is requested then no token is needed
    if (fromCache) {
        tokenConsumer = "None" /* None */;
    }
    var contextualConfig = __assign(__assign({}, requestConfig), { url: url, method: "GET" /* Get */ });
    return requestWithAuthAndRetry(function (authConfig) {
        return requestWithOfficeContext(eventName, authConfig, officeHomeApiRoot, officeCorrelationId, strategy, xhrOptions.populateRequestEvent, xhrOptions.onUploadProgress, xhrOptions.onDownloadProgress, xhrOptions.cancellationToken, xhrOptions.timeoutInMs);
    }, eventName, contextualConfig, jwtAuthEnabled, getAccessToken, tokenConsumer, xhrOptions.mockParam, xhrOptions.resourceUrl, xhrOptions.rpsHeaderPrefix, xhrOptions.additionalAuthErrors, xhrOptions.isRetriableError, xhrOptions.updateRequestWithAuth, 
    //xhrOptions.interactive,
    //xhrOptions.capDialogData,
    fromCache);
}
//# sourceMappingURL=httpGet.js.map